export const SPANISH_TRANSLATIONS = {
  // MAIN COMPONENTS
  navbar: {
    options: {
      search: 'Consultar',
      payloads: 'Payloads',
      issues: 'Incidencias',
			images: 'Imágenes',
			frauds: 'Falseos'
    },
    menu: {
      account: 'Cuenta',
      return: 'Regresar al menú',
      configuration: 'Configuración',
      logOut: 'Cerrar sesión'
    },
  },
  landing: {
    description: 'Esta herramienta nos permite consultar la información de un payload visualizando e interactuando con las fotografías pudiendo observar los productos que han sido reconocidos por el motor de imágenes.'
  },
  configuration: {
    title: 'Configuraciones',
    options: {
      appearance: 'Apariencia'
    },
    appearance: {
      themes: 'Temas',
      light: 'Claro',
      dark: 'Oscuro'
    }
  },

  // SEARCH COMPONENTS
  search: {
    title: 'Consultar Payloads',
    errorAlertMsg: 'Faltan campos por completar!',
		errorLocationAlertMsg: 'No se ha seleccionado ningún establecimiento!',
    filters: {
      organization: 'Organización',
      orgLegend: 'Selecciona una organización.',
      workspace: 'Workspace',
      workspaceLegend: 'Selecciona un workspace.',
      module: 'Módulo',
      moduleLegend: 'Selecciona un módulo.',
      searchFor: 'Buscar por:',
      searchForLegend: 'Selecciona una opción.',
      searchForOptions: {
        name: 'Nombre del establecimiento',
        code: 'Código del establecimiento',
        payloadRef: 'Referencia de payload',
        issueRef: 'Referencia de incidencia'
      },
      cycle: 'Ciclo',
      start: 'Inicio:',
      end: 'Fin:',
      cycleLegend: 'Selecciona un ciclo.',
    },
    nameOption: {
      alert: {
        msg: 'Establecimiento seleccionado!',
        name: ' Nombre:',
        code: 'Código:'
      },
      location: 'Nombre del establecimiento',
      locationLegend: 'Escribe el nombre del establecimiento.',
    },
    codeOption: {
      errorAlert: {
        msg: 'Establecimiento no encontrado!'
      },
      alert: {
        msg: 'Establecimiento encontrado!',
        name: 'Nombre:',
        code: ' Código:'
      },
      location: 'Código del establecimiento',
      locationLegend: 'Escribe el código del establecimiento.',
    },
    payloadRefOption: {
      errorAlert: {
        msg: 'Payload no encontrado!'
      },
      alert: {
        msg: 'Payload encontrado!'
      },
      input: 'Referencia del payload',
      inputLegend: 'Escribe la referencia del payload.',
    },
    issueRefOption: {
      errorAlert: {
        msg: 'Incidencia no encontrada!'
      },
      alert: {
        msg: 'Incidencia encontrada!'
      },
      input: 'Referencia de incidencia',
      inputLegend: 'Escribe la referencia de incidencia.',
    },
    imageOption: {
      errorAlert: {
        msg: 'Imagen no encontrada!'
      },
      alert: {
        msg: 'Imagen encontrada!'
      },
			title: 'Consultar Imágenes',
      input: 'Referencia de la Imagen',
      inputLegend: 'Escribe la referencia de la Imagen.',
			imgRecon: 'Reconocimiento',
			imgType: 'Tipo',
			imgGroup: 'Grupo',
			goToImage: 'Ver imagen'
    },
    searchBtn: 'Buscar'
  },
  locationsTable: {
    headers: {
      name: 'Nombre',
      code: 'Código',
      status: 'Estado'
    },
    errors: {
      noCode: 'Sin código',
      noLocations: 'No se encontraron establecimientos'
    }
  },
  locationsRecords: {
    headers: {
      type: 'Tipo',
      date: 'Fecha',
      action: 'Acción'
    },
    actions: {
      goToPayload: 'Ver payload',
      goToIssue: 'Ver incidencia'
    },
    errors: {
      noRecords: 'No hay records'
    },
    types: {
      payload: 'Payload',
      issue: 'Incidencia',
      other: 'Otro'
    }
  },

  // ALL PAYLOADS COMPONENTS
  allPayloads: {
    title: 'Consultar Payloads',
    errorAlertMsg: 'Faltan campos por completar!',
    filters: {
      organization: 'Organización',
      orgLegend: 'Selecciona una organización.',
      workspace: 'Workspace',
      workspaceLegend: 'Selecciona un workspace.',
      module: 'Módulo',
      moduleLegend: 'Selecciona un módulo.',
      submodule: 'Submódulo',
      submoduleLegend: 'Selecciona un submódulo.',
      cycle: 'Ciclo',
      cycleLegend: 'Selecciona un ciclo.',
      datePicker: 'Fecha',
      datePickerLegend: 'Selecciona una fecha o un rango de fechas.',
      areas: 'Áreas',
      areasLegend: 'Selecciona las áreas.',
      areasOptions: {
        region: 'Región',
        zone: 'Zona',
        depot: 'Depot',
        group: 'Grupo',
        route: 'Ruta'
      }
    },
    searchBtn: 'Buscar'
  },
  payloadsTable: {
    headers: {
      code: 'Código',
      date: 'Fecha',
      status: 'Estado',
      action: 'Acción'
    },
    actions: {
      goToPayload: 'Ver payload'
    },
    errors: {
      noCode: 'Sin código',
      noPayloads: 'No hay payloads',
			noImages: 'No hay imágenes'
    }
  },

  // PAYLOAD COMPONENTS
  payload: {
    title: 'Datos Generales',
    loading: 'Cargando información...',
		survey: {
			title: 'Encuesta',
			expand: 'Click para expandir',
			collapse: 'Click para minimizar'
		},
    locationInfo: {
      title: 'Información del Establecimiento',
      code: 'Código',
      name: 'Nombre',
      description: 'Descripción',
      status: 'Estatus',
      lat: 'Latitud',
      lng: 'Longitud',
      creationDate: 'Fecha de creación',
      referenceImg: 'Imagen de referencia'
    },
    payloadInfo: {
      title: 'Información de Payload',
			processType: {
				online: 'Payload enviado en modo online.',
				offline: 'Payload enviado en modo offline.'
			},
      workspace: 'Workspace',
      module: 'Módulo',
      submodule: 'Submódulo',
      config: 'Configuración',
      user: 'Usuario',
      cycle: 'Ciclo',
      creationDate: 'Fecha de creación',
      region: 'Región',
      zone: 'Zona',
      depot: 'Depot',
      group: 'Grupo',
      route: 'Ruta',
      error: 'Sin Información'
    },
    payloadStatus: {
      title: 'Estado de Payload',
      status: 'Estado',
      statusDate: 'Fecha del último estado',
      historyBtn: 'Ver historial de estado'
    },
		payloadScore: {
			loading: 'Cargando calificacion...',
      title: 'Calificación de Payload',
      score: 'Calificación Total',
			error: 'Este payload no tiene calificacion.'
    },
		payloadLocation: {
			title: 'Ubicación del Payload',
			distance: 'Distancia',
			unitM: 'm',
			unitKm: 'km',
			between: 'entre el usuario y la tienda',
		},
		rail: {
			title: 'En esta página',
			store: 'Tienda',
			details: 'Detalles',
			status: 'Estado',
			geo: 'Geo',
			score: 'Calificación',
			insights: 'Insights',
			content: 'Contenido'
		},
		payloadInsights: {
			title: 'Insights de Payload',
			loading: 'Cargando insights...',
			empty: 'Este payload no tiene insights aún.',
			ledeRest: 'de {{evaluated}} reglas evaluadas se están cumpliendo en este censo.',
			subAttentionOne: '{{count}} regla requiere atención del encargado de tienda.',
			subAttentionMany: '{{count}} reglas requieren atención del encargado de tienda.',
			subAllPass: 'Todas las reglas evaluadas se cumplieron.',
			subNotEvaluatedOne: ' {{count}} no se pudo evaluar.',
			subNotEvaluatedMany: ' {{count}} no se pudieron evaluar.',
			keystats: {
				pass: 'Cumplidas',
				fail: 'Requieren atención',
				na: 'No aplica',
				total: 'Total reglas'
			},
			viewDetails: 'Ver Detalles',
			details: {
				back: 'Volver al payload',
				stripRules: 'reglas',
				stripPass: 'cumplen',
				stripFail: 'atención',
				stripNa: 'N/A',
				filters: {
					all: 'Todas',
					fail: 'Atención',
					pass: 'Cumplidas',
					na: 'No aplica',
					searchPlaceholder: 'Buscar regla…',
					noMatches: 'No hay insights que coincidan con los filtros.'
				},
				groups: {
					pass: 'Cumplidas',
					fail: 'Requieren atención',
					na: 'No evaluables'
				},
				rowStatus: {
					pass: 'Cumple',
					fail: 'Atención',
					na: 'No aplica'
				}
			}
		},
		payloadMap: {
			point: 'Punto',
			ditance: 'Distancia',
		},
    payloadContent: {
      title: 'Contenido de Payload',
      tableHeaders: {
        type: 'Tipo',
        info: 'Información',
        images: 'Imágenes'
      },
      errors: {
        noContent: 'Sin Información'
      }
    },
		reportError: {
			banner: {
				title: '¿Encontraste un error en este payload?',
				desc: 'Reporta problemas con la calificación o con las fotos de este payload. Backoffice revisa tu reporte y solo puede existir una revisión activa por payload.',
				btn: 'Reportar error',
				expiredTitle: 'Ventana de reporte cerrada',
				expiredDesc: 'Han pasado más de {{days}} días desde la fecha de este payload. Ya no es posible levantar un ticket sobre él.',
				activeTitle: 'Ya existe un ticket sobre este payload',
				activeDesc: 'Backoffice está revisando tu reporte. Podrás levantar otro cuando este se resuelva.',
			},
		},
		share: {
			prompt: '¿Necesitas compartir este payload?',
			copyUrl: 'Copiar URL',
			copied: '¡Copiado!',
		}
  },
  statusModal: {
    title: 'Historial de Estado',
    tableHeaders: {
      prevStatus: 'Estado previo',
      currentStatus: 'Estado actual',
      date: 'Fecha'
    },
    errors: {
      noHistory: 'Sin Información'
    }
  },

  // ISSUE COMPONENTS
  issue: {
    allIssues: {
      title: 'Incidencias',
      issueTypeLegend: 'Selecciona un tipo de incidencia.',
    },
    issueInfo: {
      title: 'Información de la Incidencia',
			processType: {
				online: 'Incidencia enviada en modo online.',
				offline: 'Incidencia enviada en modo offline.'
			}
    },
    issueType: {
      title: 'Tipo de la Incidencia',
      issue_tag: 'Tipo(s) de etiqueta(s) personalizada: ',
      descriptions: {
        closed: 'El establecimiento está cerrado.',
        closed_down: 'El establecimiento está cerrado permanentemente.',
        access: 'No fue permitido el acceso al interior del establecimiento.',
        process: 'No fue permitido realizar la evaluación al establecimiento.',
        products: 'El establecimiento no cuenta con productos relacionados con la organización.',
        custom: 'Incidencia personalizada.'
      }
    },
    issuesTable: {
      headers: {
        code: 'Código',
        date: 'Fecha',
        type: 'Tipo',
        action: 'Acción'
      },
      actions: {
        goToIssue: 'Ver incidencia'
      },
      errors: {
        noCode: 'Sin código',
        noIssues: 'No hay incidencias'
      }
    }
  },

  // DISPLAY COMPONENTS
  display: {
    returnPayload: 'Regresar al payload',
    returnSurvey: 'Regresar a encuesta',
		recon: 'Reconocimiento de Productos',
		imgInfo: {
			title: 'Información de la imagen',
			name: 'Nombre',
			type: 'Tipo',
			original: 'Original',
			globalTags: 'Etiquetas globales',
			resourceTags: 'Etiquetas de recursos',
		},
		numTickets: 'Número de Tickets',
    imgType: 'Tipo:',
    imgName: 'Nombre:',
		resultHistory: 'Historial de results',
    loading: 'Cargando result...',
    globalTags: 'Etiquetas globales: ',
    resourceTags: 'Etiquetas de recursos: ',
    resultTypes: 'Tipos de result:',
    alert: 'No existen reconocimientos para esta imagen.',
		alertTitle: 'Sin reconocimiento disponible',
		alertArchive: 'Esta imagen ha sido accedida desde el archivo de almacenamiento en la nube.',
		archiveTitle: 'Imagen desde archivo en la nube',
    resultInfo: {
      elements: 'Elementos',
      predictions: 'Predicciones',
      extras: 'Extras'
    },
    photosBtns: {
      previous: 'Foto Anterior',
      next: 'Siguiente Foto'
    },
    errors: {
      image: 'Error al cargar la imagen'
    },
    actionBtns: {
      fullScreen: 'Abrir en nueva ventana',
      download: 'Descargar imagen',
      fitImg: 'Ajustar imagen',
      createTicket: 'Crear Ticket',
      controls: 'Atajos de teclado',
    },
    productsGraph: 'Gráfica de Productos',
		reconModel: {
			model: 'Modelo',
			version: 'Versión',
		},
		rail: {
			title: 'Secciones',
			info: 'Info',
			recon: 'Reconocimiento',
		},
		recognition: {
			title: 'Reconocimiento',
			empty: 'Selecciona un tipo de resultado para ver los elementos detectados.',
			unsupportedType: 'Sin vista de lista para este tipo de resultado.',
			showing: 'Mostrando',
		},
		result: {
			typesLabel: 'Tipos de resultado',
		},
		summary: {
			title: 'Resumen del reconocimiento',
		},
		chart: {
			title: 'Distribución de productos',
		},
		taglist: {
			title: 'Elementos detectados',
			products: 'Productos',
			fronts: 'Frentes',
			hideAll: 'Ocultar todos',
			showAll: 'Mostrar todos',
			opacity: 'Ajustar opacidad',
			doors: 'Puertas',
		},
		reportError: {
			title: 'Reportar error',
			ticketPrefix: 'Reporte desde Display',
			step: 'Paso {{current}} / {{total}}',
			cancel: 'Cancelar',
			back: 'Volver',
			submit: 'Enviar reporte',
			sending: 'Enviando...',
			banner: {
				title: '¿El motor cometió un error?',
				desc: 'Reporta correcciones sobre los productos detectados. Tu calificación se recalcula al instante (provisional), y backoffice revisa tus cambios. Solo puede existir una revisión activa por foto.',
				btn: 'Reportar error',
				resolved: {
					ctaAgain: 'Reportar de nuevo',
					ctaNew: 'Levantar nuevo',
					// Attribution for the QA note. Fixed on purpose: the history entry
					// never names the actor, so the note is credited to the team.
					note: {
						author: 'Backoffice',
					},
					approved: {
						title: 'Tu reporte fue aprobado',
						desc: 'Los cambios ya se aplicaron. Si detectas otro problema, puedes levantar un nuevo ticket.',
					},
					partial: {
						title: 'Tu reporte fue aprobado parcialmente',
						desc: 'Backoffice aplicó parte de tus correcciones. Si quieres reportar lo que quedó, puedes levantar un ticket adicional.',
					},
					rejected: {
						title: 'Tu reporte fue rechazado',
						desc: 'Backoffice determinó que no procedía la corrección. Si sigues viendo un problema, puedes reportar de nuevo con más contexto.',
					},
					closed: {
						title: 'Este ticket quedó cerrado',
						desc: 'Se cerró sin acción específica. Si el problema persiste, puedes levantar un ticket nuevo.',
					},
					outdated: {
						title: 'El reporte quedó desactualizado',
						desc: 'La información cambió antes de que backoffice pudiera resolverlo. Si el problema sigue vigente en la versión actual, levanta un ticket nuevo.',
					},
					error: {
						title: 'Ocurrió un error al aplicar tu reporte',
						desc: 'Backoffice aprobó tus cambios pero el sistema no pudo aplicarlos. Puedes intentarlo con un ticket nuevo o contactar a soporte si persiste.',
					},
				},
				// Cajón de la bitácora del ticket, abierto desde el botón del banner.
				// `author` es fijo a propósito: la entrada del historial no nombra al
				// actor — ver pickStatusNote en ticketActions.js.
				history: {
					btn: 'Ver historial del ticket',
					title: 'Historial de estado',
					eyebrow: 'Ticket {{code}}',
					eyebrowFallback: 'Ticket',
					empty: 'Sin historial disponible.',
					author: 'Backoffice',
					close: 'Cerrar historial',
				},
				expiredTitle: 'Ventana de reporte cerrada',
				expiredDesc: 'Han pasado más de {{days}} días desde la fecha de este payload. Ya no es posible levantar un ticket sobre él.',
				activeTitle: 'Ya existe un ticket sobre este payload',
				activeDesc: 'Backoffice está revisando tu reporte. Podrás levantar otro cuando este se resuelva.',
			},
			createErrors: {
				duplicate: 'Ya existe un ticket abierto sobre este elemento. Espera a que backoffice lo resuelva para poder levantar otro.',
				foreignOrg: 'Este elemento pertenece a otra organización, no es posible reportarlo.',
				reasonTarget: 'Esta razón no aplica a este tipo de elemento. Elige otra.',
				noProposal: 'La razón seleccionada no admite una corrección.',
			},
			step1: {
				heading: '¿Qué tipo de error encontraste?',
				subtext: 'Selecciona la categoría que mejor describe el problema. Esto lo enruta al equipo correcto.',
			},
			step2: {
				heading: 'Describe el problema',
				subtext: 'Backoffice revisará tu reporte. Cuando se resuelva, verás el resultado aquí mismo.',
				detailsLabel: 'Detalles del error',
				placeholder: 'Describe qué valor esperabas, qué viste, o qué fue lo incorrecto...',
				required: 'Este campo es obligatorio.',
				minHint: 'Mínimo {{min}} caracteres.',
				minChars: 'Se requieren al menos {{min}} caracteres.',
				notice: 'Este tipo de error no se auto-corrige: será revisado manualmente por el equipo de soporte.',
			},
			categories: {
				score: {
					title: 'Nota mal calculada',
					desc: 'La calificación final no refleja lo que ves en la foto, aunque los productos estén bien reconocidos.',
				},
				recognition: {
					title: 'Error de reconocimiento',
					desc: 'Productos mal identificados, falsos positivos, o cajas faltantes sobre la foto.',
				},
				autocorrect: {
					title: 'Auto-corrección de reconocimiento',
					desc: 'Puedes corregir los productos manualmente al instante. La calificación se recalcula de inmediato.',
					badge: 'Próximamente',
				},
			},
		},
		shortcuts: {
			scroll: 'Rueda del mouse',
			leftClick: 'Clic izquierdo',
		},
		hero: {
			photoOf: 'Foto {{current}} de {{total}}',
		},
  },
	controlsModal: {
		zoom: 'Acercar / Alejar',
		move: 'Desplazarse por la imagen',
	},
	tour: {
		launcher: 'Tomar el tour',
		skip: 'Omitir',
		back: 'Atrás',
		next: 'Siguiente',
		done: 'Listo',
		payloadNew: {
			rail: {
				title: 'Navegación rápida',
				body: 'Desde este menú lateral saltas directo a cualquier sección de la página. Se mantiene visible mientras haces scroll.',
			},
			identity: {
				title: 'Información de la tienda',
				body: 'Información general de la tienda: foto de fachada (si existe), nombre, código, Id, ubicación y fecha de creación en sistema. Aquí también ves si el payload se envió en modo online u offline.',
			},
			payload: {
				title: 'Información del payload',
				body: 'Workspace, módulo, submódulo, configuración, usuario, ciclo y área geográfica. Toda la metadata operativa del registro.',
			},
			status: {
				title: 'Estado del payload',
				body: 'Estado actual del payload con la fecha de su última actualización. Tienes acceso al historial completo para ver todos los estados por los que pasó.',
			},
			location: {
				title: 'Ubicación del payload',
				body: 'Mapa con la posición de la tienda (rojo) y donde el usuario comenzó el censo (azul). La distancia entre ambos puntos aparece en el panel derecho.',
			},
			score: {
				title: 'Calificación del payload',
				bodyBefore: 'Calificación global y desglose por grupos de indicadores. Cada KPI muestra su puntaje y un',
				bodyAfter: 'con contexto adicional cuando aplica.',
			},
			insights: {
				title: 'Insights del payload',
				body: 'Resumen de reglas evaluadas — cuántas aprueban, fallan o no aplican. Tienes acceso a la vista detallada con todas las reglas individuales.',
			},
			content: {
				title: 'Contenido del payload',
				body: 'Datos del formulario que llenó el usuario en campo: cada respuesta con su pregunta y, cuando aplique, las fotos asociadas.',
			},
			pdf: {
				title: 'Descargar ficha técnica',
				body: 'Genera un PDF con el resumen completo del payload, descargable en un click.',
			},
			share: {
				title: 'Compartir el URL',
				body: 'Copia el link de este payload al portapapeles para mandárselo a alguien más con un solo click.',
			},
		},
		surveyResponse: {
			rail: {
				title: 'Navegación rápida',
				body: 'Desde este menú lateral saltas directo a cualquier sección de la página. Se mantiene visible mientras haces scroll.',
			},
			identity: {
				title: 'Información de la tienda',
				body: 'Información general de la tienda: foto de fachada (si existe), nombre, código, Id, ubicación y fecha de creación en sistema.',
			},
			payload: {
				title: 'Información de la encuesta',
				body: 'Schema, usuario, workspace y la fecha en que se envió la respuesta. Toda la metadata operativa del registro.',
			},
			score: {
				title: 'Calificación de la encuesta',
				bodyBefore: 'Calificación global y desglose por grupos de indicadores. Cada KPI muestra su puntaje y un',
				bodyAfter: 'con contexto adicional cuando aplica.',
			},
			content: {
				title: 'Contenido de la encuesta',
				body: 'Datos del formulario que llenó el usuario en campo: cada respuesta con su pregunta y, cuando aplique, las fotos asociadas.',
			},
		},
		displayNew: {
			rail: {
				title: 'Navegación rápida',
				body: 'Desde este menú lateral saltas directo a cualquier sección de la página. Se mantiene visible mientras haces scroll.',
			},
			info: {
				title: 'Información de la imagen',
				body: 'Nombre del archivo, tipo y etiquetas asociadas a la imagen. El Id de la imagen aparece junto al título de la sección y se copia con un click.',
			},
			toolbar: {
				title: 'Controles del reconocimiento',
				body: 'Cambia entre los tipos de resultado cuando la imagen tiene más de uno, y elige qué capa de detecciones quieres ver.',
			},
			history: {
				title: 'Historial de resultados',
				body: 'Consulta resultados anteriores para esta imagen. Solo disponible para usuarios Percepthor; útil para debugging o comparar corridas.',
			},
			picbtns: {
				title: 'Controles de imagen',
				body: 'Ajusta la imagen al marco, ábrela en una ventana nueva, descárgala, o consulta el modal con los atajos de teclado.',
			},
			taglist: {
				title: 'Items detectados',
				body: 'Lista de productos detectados con su color, cantidad y metadata. Muestra u oculta cada uno o todos a la vez, y ajusta la opacidad de los recuadros.',
			},
			caption: {
				title: 'Modelo y versión',
				body: 'Modelo y versión que generaron el resultado actual. Útil para comparar corridas o identificar qué configuración se usó.',
			},
			summary: {
				title: 'Resumen del reconocimiento',
				body: 'Campos custom que regresó el resultado, como conteos de marca o métricas de anaquel, en formato de resumen rápido.',
			},
			chart: {
				title: 'Distribución de productos',
				body: 'Gráfica de barras horizontales ordenada por cantidad. Cambia el agrupamiento (productos, marca, tipo, etc.) para ver distintos agregados.',
			},
		},
	},
  ticketModal: {
    instuction: 'Si no has seleccionado un result, selecciónalo antes de crear un ticket.',
    project: 'Proyecto',
    name: 'Nombre',
    description: 'Descripción',
    cancel: 'Cancelar',
    create: 'Crear',
    creating: 'Creando...'
  },
  tagList: {
    colorSwal: {
      title: 'Ajuste de trasparencia',
			text: 'Transparencia de color para los artículos',
    },
    tableHeaders: {
      color: 'Color',
      quantity: 'Cantidad',
      products: 'Productos',
      price: 'Precio',
      score: 'Puntaje'
    },
    errors: {
      noProducts: 'Sin productos'
    }
  },
	reconTable: {
		productCount: 'Num. de Productos',
		frontCount: 'Num. de Frentes'
	},
  tagChart: {
    errors: {
      noProducts: 'Sin productos'
    }
  },

	// TICKETS COMPONENTS
	tickets: {
		filters: {
			projectLegend: 'Selecciona un proyecto.',
		},
		help: {
			title: '¿Qué proyeto debo seleccionar?',
			msg: 'Los proyectos que comienzan con "Test -" contienen tickets destinados a la realización de pruebas internas. Los demás proyectos contienen tickets que están orientados a su revisión y corrección en entorno de producción.'
		}
	},
	ticketsTable: {
		errors: {
			noTickets: 'No hay tickets'
		}
	},

	// FRAUD
	fraud: {
		allFraudsTitle: 'Consultar Falseos de Información',
		alert: {
			msg: 'Se detectó que este establecimiento tiene una posible duplicidad en alguna de sus fotografías.',
			link: 'Ver reporte',
			btn: 'Visualizar reporte de posible falseo'
		},
		title: 'Reporte de Falsificación de Información',
		print: 'Imprimir',
		false: 'Falsificación',
		data: {
			image: 'Imagen',
			imageDate: 'Fecha de Captura',
			coordinates: 'Coordenadas'
		},
		image: 'Similitud de imagen',
		products: 'Similitud de producto',
		validationBtn: 'Comenzar proceso de validación',
		reviewMsg: 'La información ha sido verificada por el supervisor.',
		confirm: {
			title: '¿Estás seguro de que quieres comenzar el proceso de validación?',
			msg: 'Esta acción agregará el establecimiento a tu ruta y no se puede deshacer.'
		},
		alerts: {
			success: 'El proceso ha comenzado, revisa tu ruta en la app.',
			error: 'Error, intenta de nuevo por favor'
		},
		errorPageTitle: 'Este payload no cuenta con falsificación de información.'
	},

  // UTILS COMPONENTS
  selectButton: {
    placeholder: 'Seleccionar...',
    noOptionsMessage: 'Sin opciones',
		loadingMessage: 'Cargando opciones...'
  },
  pagination: {
		rows: 'Filas por página:',
    of: 'de'
  },
	confirmDialog: {
		confirmBtn: 'Confirmar',
	},

  // STATUS DESCRIPTIONS
  statusDesc: {
    payload: {
      none: 'None',
      created: 'Creado',
      waiting: 'Esperando',
      processing: 'Procesando',
      good: 'Correcto',
      incomplete: 'Incompleto',
      bad: 'Incorrecto',
      flagged: 'Marcado',
      in_review: 'En revisión',
      passed: 'Pasado',
      removed: 'Eliminado',
      error: 'Error'
    },
		imgStatus: {
			none: 'None',
			available: 'Disponible',
			lost: 'Perdido',
			review: 'En revisión',
			blocked: 'Bloqueado',
			missing: 'Faltante',
			removed: 'Eliminado',
			archived: 'Archivado',
		},
    imgRecon: {
      none: 'None',
      waiting: 'Esperando',
      success: 'Correcto',
      error: 'Error',
      reviewed: 'Revisado',
      unavailable: 'No disponible'
    },
		imgType: {
			none: 'None',
			common: 'Común',
			upload: 'Carga',
			output: 'Salida',
			backup: 'Respaldo'
		},
		imgGroup: {
			none: 'None',
			organization: 'Organización',
			module: 'Módulo',
			location: 'Establecimiento',
			payload: 'Payload',
			result: 'Result',
			issue: 'Incidencia',
			post: 'Post',
			notification: 'Notificación'
		},
    location: {
      none: 'None',
      available: 'Disponible',
      disabled: 'Desactivada',
      removed: 'Eliminada'
    },
    record: {
      none: 'None',
      payload: 'Payload',
      issue: 'Incidencia',
			retry: 'Reintentar',
      other: 'Otro'
    },
    issue: {
      none: 'None',
      closed: 'Cerrado',
      closed_down: 'Cerrado permanentemente',
      access: 'Acceso',
      process: 'No se evaluó',
      products: 'No tiene productos',
      custom: 'Personalizada'
    },
    cycle: {
      none: 'None',
      created: 'Creado',
      starting: 'Empezando',
      available: 'Disponible',
      waiting: 'Esperando',
      completed: 'Completado',
      removed: 'Eliminado'
    },
		ticket: {
			none: 'None',
			open: 'Abierto',
			review: 'En revisión',
			approved: 'Aprobado',
			partial: 'Aprobado parcialmente',
			rejected: 'Rechazado',
			// Legado: el backend ya no escribe 6, pero los tickets resueltos
			// antes del cambio siguen en ese estado.
			closed: 'Cerrado',
			outdated: 'Desactualizado',
			error: 'Error'
		}
  },

  // SURVEYS COMPONENTS
  surveys: {
    list: {
      title: 'Encuestas',
      filters: {
        schema: 'Schemas',
        schemaLegend: 'Selecciona un schema.',
        from: 'Desde',
        to: 'Hasta',
        dateLegend: 'Filtra por rango de fechas (opcional).',
        code: 'Código de tienda',
        codeLegend: 'Filtra por código de tienda (opcional).',
        codePlaceholder: 'Ej. 117812672',
        areasLegend: 'Filtra por región, zona, depósito, grupo o ruta (opcional).',
        searchType: {
          label: 'Buscar por',
          byCode: 'Código de tienda',
          byRoute: 'Ruta',
          routeUnavailable: 'El schema seleccionado no soporta búsqueda por ruta.'
        },
        clear: 'Limpiar filtros'
      },
      table: {
        source: 'Fuente',
        reference: 'Referencia',
        name: 'Nombre',
        code: 'Código',
        route: 'Ruta',
        depot: 'CEDIS',
        photos: 'Fotos',
        action: 'Ver',
        copyOid: 'Copiar ID',
        noResults: 'Sin resultados'
      },
      chart: {
        title: 'Capturas por día',
        total: 'total en el periodo',
        empty: 'Sin capturas en el periodo.',
        loading: 'Cargando…'
      },
      quickLookup: {
        title: 'Ir directamente por ID',
        help: 'Si conoces el ID de la respuesta, abre su detalle sin aplicar filtros.',
        idLabel: 'ID de respuesta',
        placeholder: 'Pega aquí el ID de la respuesta',
        goBtn: 'Ir al detalle',
        loading: 'Buscando...',
        invalidId: 'No se encontró una respuesta con esa referencia.'
      }
    },
    response: {
      title: 'Detalle de Encuesta',
      info: {
        title: 'Información de la Encuesta',
        schema: 'Schema',
        user: 'Usuario',
        workspace: 'Workspace',
        creationDate: 'Fecha de creación'
      },
      content: {
        title: 'Contenido de Encuesta',
        noContent: 'Sin contenido disponible'
      },
      share: {
        prompt: '¿Necesitas compartir esta encuesta?',
        copyUrl: 'Copiar URL',
        copied: '¡Copiado!'
      },
      inspection: {
        launcher: 'Inspeccionar',
        back: 'Volver a la encuesta',
        title: 'Inspección',
        eyebrow: 'Inspección GEPP',
        loading: 'Cargando inspección…',
        refetching: 'Actualizando…',
        noDomain: 'Esta encuesta no tiene source; no es posible inspeccionar.',
        checks: 'Verificaciones',
        timeline: 'Línea de tiempo',
        geppLogs: 'Ciclo de vida GEPP',
        monitor: 'Monitor y pasos',
        requests: 'Peticiones HTTP',
        files: 'Archivos',
        counts: 'Conteos relacionados',
        raw: 'JSON crudo',
        copyJson: 'Copiar JSON',
        copy: 'Copiar',
        copied: 'Copiado',
        jsonTitle: 'json'
      }
    }
  }
};
